// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PasswordReset-m_pRjJ2Ox4DPx5T12Im24e {
    border: 1px solid #cecece;
    display: flex;
    flex-direction: column;
    background-color: var(--text-white);
    padding: 1.5rem;
    width: 20%;
    align-items: center;
    border-radius: 5px;
    box-shadow: 4.0px 8.0px 8.0px hsl(0deg 0% 0% / 0.38);
}

.PasswordReset-m_u2D9_21nUHXNQ5fvLZX7 {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.PasswordReset-m_u2D9_21nUHXNQ5fvLZX7 > * {
    margin-bottom: 1rem;
}

.PasswordReset-m_kt4RhemGg4cpsMKGYjUr {
    color: var(--error-foreground);
    background-color: var(--error-background);
    border: 1px solid var(--error-foreground);
    padding: .5rem;
    font-size: .8rem;
}

.PasswordReset-m_ww8Of6g8IgsNsXxU3mhD {
  width: auto;
}`, "",{"version":3,"sources":["webpack://./client/login/PasswordReset/PasswordReset.m.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mCAAmC;IACnC,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,yCAAyC;IACzC,yCAAyC;IACzC,cAAc;IACd,gBAAgB;AACpB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".passwordReset {\n    border: 1px solid #cecece;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--text-white);\n    padding: 1.5rem;\n    width: 20%;\n    align-items: center;\n    border-radius: 5px;\n    box-shadow: 4.0px 8.0px 8.0px hsl(0deg 0% 0% / 0.38);\n}\n\n.passwordResetForm {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.passwordResetForm > * {\n    margin-bottom: 1rem;\n}\n\n.error {\n    color: var(--error-foreground);\n    background-color: var(--error-background);\n    border: 1px solid var(--error-foreground);\n    padding: .5rem;\n    font-size: .8rem;\n}\n\n.button {\n  width: auto;\n}"],"sourceRoot":""}]);
// Exports
export var passwordReset = `PasswordReset-m_pRjJ2Ox4DPx5T12Im24e`;
export var passwordResetForm = `PasswordReset-m_u2D9_21nUHXNQ5fvLZX7`;
export var error = `PasswordReset-m_kt4RhemGg4cpsMKGYjUr`;
export var button = `PasswordReset-m_ww8Of6g8IgsNsXxU3mhD`;
export default ___CSS_LOADER_EXPORT___;
